// import react from 'react';
import { DateTime } from "luxon";

import cloneDeep from 'lodash/cloneDeep';
import { DAY_WIDTH_IN_PIXELS } from "../plannerViewTeamCard";
import { parseTimeStringToMs } from "../../../general_components/content_management/task_list/taskListElements/diagramView";

export const WARNINGS_ARRAY = ["Conflicting times with prev. load",
                                "Not enough HOS",
                                "Running late"];
export function extractStopLatLng(stop){
    if (!stop) return null;
    const value = stop.latLng || stop.address?.latLng;
    if (value == null) return null;
    const text = String(value).trim();
    return text || null;
}
export function stopToObjectDetails(stop){
    try {
        let sourceDateTime;
        let windowDuration = null;
        let apptTimeProvided = false;
        let timezone = stop["address"]["timezone"];

        const apptTimeString = stop["apptTime"];
        if( apptTimeString && apptTimeString !== ""){
            const apptTimeArray =  apptTimeString.split(' - ');
            apptTimeProvided = true;
            sourceDateTime = DateTime.fromFormat(
                `${stop["apptDate"]} ${apptTimeArray[0]}`,
                "MM/dd/yy hh:mm a",
                { zone:  timezone,
                    locale: "en-US"
                }
            );
            if(apptTimeArray.length > 1){
                const startTime = DateTime.fromFormat(apptTimeArray[0], 'hh:mm a');
                const endTime = DateTime.fromFormat(apptTimeArray[1], 'hh:mm a');
                windowDuration = endTime.diff(startTime, 'hours').hours;
            }
            
        }else{
            sourceDateTime = DateTime.fromFormat(
                `${stop["apptDate"]} 00:00 AM`,
                "MM/dd/yy hh:mm a",
                { zone: timezone,
                    locale: "en-US" 
                }
            );
        }
        return {
            stopCity : stop["address"].city,
            stopState : stop["address"].state,
            apptTimeProvided : apptTimeProvided,
            appt : sourceDateTime.toFormat("yyyy-MM-dd HH:mm ZZ"),
            lbl : apptTimeProvided ? sourceDateTime.toFormat("MM/dd HH:mm")+" "+sourceDateTime.offsetNameShort : sourceDateTime.toFormat("MM/dd")+" "+sourceDateTime.offsetNameShort,
            windowDuration: windowDuration,
            stopStatus: stop["status"],
            latLng: extractStopLatLng(stop)
        }
    } catch (error) {
        console.log(error);
        return {
        }
    }
}
// export function calculateWithByDistance(distance, timelineStartInMilleseconds){
//     //(distance / speed) * 60 * 60 * 1000;
//     const timeRequiredToCoverTheDistanceInMills = (distance / 55) * 60 * 60 * 1000;
//     return {
//         millsRequired: timeRequiredToCoverTheDistanceInMills,
//         newWidth : calculateOffset(timelineStartInMilleseconds + timeRequiredToCoverTheDistanceInMills, timelineStartInMilleseconds)
//     }
// }
export function calculateOffset(firstTime, secondTime){
    const diffMinutes = (firstTime - secondTime) / (1000 * 60);
    return parseInt(diffMinutes * (DAY_WIDTH_IN_PIXELS/1440));
}
export function offsetToDuration(offset) {
    return offset * (1440 / DAY_WIDTH_IN_PIXELS);
}
function plus24H(time, dayCount){
    if(dayCount){
        return time + ((24 * 60 * 60 * 1000) * dayCount);
    }
    return time + (24 * 60 * 60 * 1000);
}
export class HomeTime{
    id;
    address;
    apptTime;
    apptDate;
    desc;
    type;
    startOffset;
    width;
    dispatched;
    warningIndicatorStartOffset;
    currentTask;
    actionIndex
    constructor (hometimeObject, timelineStartInMilleseconds, leftBorder, rightBorder, currentTimeRef){
        
        this.id = hometimeObject.id;
        this.address = hometimeObject.address;
        this.apptTime = hometimeObject.apptTime;
        this.apptDate = hometimeObject.apptDate;
        this.currentTask = hometimeObject.currentTask;
        for(const action of hometimeObject.actionsArray){
            if(action.type === "homeTime" || action.type === "reset"){
                this.type = action.type;
                this.desc = action.desc;
                this.actionIndex = action.actionIndex;
                this.dispatched = action.dispatched;
                const providedLeftBorder = Math.max(leftBorder, calculateOffset(currentTimeRef.current.toMillis(), timelineStartInMilleseconds));
                
                // this.startOffset = action.startTime ? Math.max(providedLeftBorder, calculateOffset(action.startTime, timelineStartInMilleseconds)): providedLeftBorder;
                
                this.startOffset = leftBorder && action.startTime ?  Math.max(leftBorder, calculateOffset(action.startTime, timelineStartInMilleseconds)) : action.startTime ? calculateOffset(action.startTime, timelineStartInMilleseconds) : leftBorder ? leftBorder : providedLeftBorder ;
                
                if(action.type !== "reset"){
                    const timeUntilHometimeInPixels = (this.startOffset - providedLeftBorder);
                    if(timeUntilHometimeInPixels > DAY_WIDTH_IN_PIXELS / 2 && timeUntilHometimeInPixels < (DAY_WIDTH_IN_PIXELS * 9)){
                        this.warningIndicatorStartOffset = providedLeftBorder;
                    }
                }
                
                
                if(action.endTime){
                    this.width =  Math.min(rightBorder || 9999999999999, calculateOffset(action.endTime, timelineStartInMilleseconds)) - this.startOffset;
                }else{
                    if(action.durationInDays){
                        this.width =  action.type !== "reset" ? action.durationInDays * DAY_WIDTH_IN_PIXELS : action.durationInDays * (DAY_WIDTH_IN_PIXELS/24);
                    }else{
                        this.width = (rightBorder || calculateOffset(plus24H(timelineStartInMilleseconds, 9), timelineStartInMilleseconds)) - this.startOffset;
                    }
                }
                if(this.startOffset < 0){
                    this.width = this.width + this.startOffset;
                    this.startOffset = 0;
                }
                if(this.startOffset + this.width > DAY_WIDTH_IN_PIXELS*9){
                    this.width = (DAY_WIDTH_IN_PIXELS*9) - this.startOffset +  35;
                }
                break;
            }
        }
    }
}
export class LoadObject{
    loadId;
    loadNumber;
    status;
    loadType;
    mileage;
    deadhead;
    puCity;
    puState;
    puLatLng;
    destCity;
    destState;
    destLatLng;
    delState;
    startOffset;
    width;
    loadsFirstActionSpecified;
    loadsLastActionSpecified;
    currentLoad;
    pickupWindowWidth;
    previousLoadsActionTime;
    reliesOnCurrentTimeLine;
    hasToCheckInBefore;
    upcomingLoad;
    actualCurrentLoad;
    loadStartDateTime;
    loadEndDateTime;
    amountForInvoice;
    providedStartTime;
    nextLoadId;
    warnings = {};
    etaData;
    startPercentage;
    endPercentage;
    // inbetweenStops;
    constructor (input, timelineStartInMilleseconds, lastSpecifiedActionTime, currentTimeRef, currentLoad, upcomingLoad, truckId){  
        if (typeof input === 'object' && input !== null) {
            this.upcomingLoad = upcomingLoad;
            this.loadNumber = input["loadNumber"];
            this.reliesOnCurrentTimeLine = false;
            const currentTimeInMills = currentTimeRef.current ? currentTimeRef.current.toMillis() : null;
            this.currentLoad = currentLoad;
            this.loadId = input["id"];
            const startEndPercentages = applyStartEndPercentages(input, truckId);
            if(startEndPercentages.startPercentage){
                this.startPercentage = startEndPercentages.startPercentage;
            }
            if(startEndPercentages.endPercentage){
                this.endPercentage = startEndPercentages.endPercentage;
            }
            
            this.status = input["loadStatus"] === "Paid" || input["loadStatus"] === "Invoiced" ? "ReadyForInvoice" : input["loadStatus"];
            if(this.currentLoad && !this.upcomingLoad){
                this.actualCurrentLoad = input;
                let lastCompletedStopIndex = -1;
                if(this.status === "Dispatched" || this.status === "InProgress"){
                    for(const stop of input.stops){
                        if(!stop.status){
                            break;
                        }else if(stop.status === "inProgress"){
                            this.status = "Onsite";
                            break;
                        }else if(stop.status === "completed"){
                            lastCompletedStopIndex++;
                        }
                    }
                }
                  
                // if(input.loadNumber === "5126632XTZ"){
                //     console.log(lastCompletedStopIndex);
                //     console.log(input.trucksETA);
                // }
                if(this.status !== "Onsite" && input.trucksETA && input.trucksETA.stopNumber > (lastCompletedStopIndex + 1)){
                    const etaData = {...input.trucksETA};
                    
                    if(!etaData.pending ){
                        try {
                            this.etaData = etaData;
                            // if(etaData.late){
                            //     this.warnings["2"] = true;
                            // }
                            if(etaData.stopNumber === 1){
                                etaData.etaToFirstStop = true;
                                delete etaData.stopNumber;
                            }else if(etaData.stopNumber === input.stops.length){
                                etaData.etaToLastStop = true;
                                delete etaData.stopNumber;
                            }else{
                                
                                const stopObjectDetails = stopToObjectDetails(input.stops[etaData.stopNumber-1]);
                                this.etaData.stopTimeLbl = stopObjectDetails.lbl;
                                this.etaData.stopCityState = `${stopObjectDetails.stopCity}, ${stopObjectDetails.stopState}`;
                                this.etaData.stopLatLng = stopObjectDetails.latLng || null;
                            }
                            // else{
                            //      = etaData.eta;
                            // }
                        } catch (error) {
                        }
                    }
                }
            }            
            if(this.currentLoad){
                this.amountForInvoice = input["amountForInvoice"]
            }
            
            this.mileage = input["mileage"];
            
            if(this.startPercentage && this.endPercentage){
                this.mileage = this.mileage * (this.endPercentage - this.startPercentage);
            }else if(this.startPercentage){
                this.mileage = this.mileage * (1.0 - this.startPercentage);
            }else if(this.endPercentage){
                this.mileage = this.mileage * this.endPercentage;
            }

            this.mileage = Math.round(this.mileage);
            // this.deadhead = input["deadhead"];
            this.loadType = input['loadType'];       
            this.previousLoadsActionTime = lastSpecifiedActionTime;
            const firstStopCheckIn = input.stops?.[0]?.checkIn;
            const lastStopCheckOut = input.stops?.[input.stops.length - 1]?.checkOut;
            let firstPuCheckInTimeInMilliseconds = firstStopCheckIn ? DateTime.fromISO(firstStopCheckIn, { setZone: true }).toMillis() : null;
            
            let lastDelCheckOutTimeInMilliseconds = lastStopCheckOut ? DateTime.fromISO(lastStopCheckOut, { setZone: true }).toMillis() : null;  
            
            if (firstPuCheckInTimeInMilliseconds && lastDelCheckOutTimeInMilliseconds
                && Math.abs(firstPuCheckInTimeInMilliseconds - lastDelCheckOutTimeInMilliseconds) < (15 * 60 * 1000)) {
                // difference between checkin and checkout is less than 15 minutes
                firstPuCheckInTimeInMilliseconds = null;
            }
            let firstStopObj = stopToObjectDetails(input.stops[0]);
            let lastStopObj = stopToObjectDetails(input.stops[input.stops.length-1]);
            this.loadStartDateTime = firstStopObj.lbl;
            
            const providedTime = new Date(firstStopObj.appt).getTime();
            this.puCity = firstStopObj.stopCity;
            this.puState = firstStopObj.stopState;
            this.puLatLng = firstStopObj.latLng || null;

            // if(firstStopObj.stopStatus === "inProgress"){
            //     this.status = "Onsite";
            //     this.etaData = null;
            //     delete this.warnings["1"];
            // }

            if(!this.startPercentage && this.currentLoad && !this.upcomingLoad && (firstStopObj.stopStatus === "inProgress" || firstStopObj.stopStatus === "completed") ){
                firstPuCheckInTimeInMilliseconds = Math.max(lastSpecifiedActionTime, firstPuCheckInTimeInMilliseconds || Math.min(providedTime, currentTimeInMills));
                this.startOffset =  calculateOffset(firstPuCheckInTimeInMilliseconds, timelineStartInMilleseconds);
            }else if(this.startPercentage){
                const endTime = new Date(lastStopObj.appt).getTime();
                const diff = endTime - providedTime;
                firstPuCheckInTimeInMilliseconds= Math.max(providedTime + (diff * this.startPercentage), lastSpecifiedActionTime + 1800000);
                this.startOffset =  calculateOffset(firstPuCheckInTimeInMilliseconds, timelineStartInMilleseconds);

            }else if(firstPuCheckInTimeInMilliseconds && !firstStopObj.apptTimeProvided){
                this.startOffset =  calculateOffset(firstPuCheckInTimeInMilliseconds, timelineStartInMilleseconds);
            }else{
                if(currentLoad){
                    if(firstStopObj.apptTimeProvided){
                        const endOfThePickupWindow = !firstStopObj.windowDuration ? null : providedTime + (firstStopObj.windowDuration * 60 * 60 * 1000);
                        firstPuCheckInTimeInMilliseconds = providedTime < lastSpecifiedActionTime ? lastSpecifiedActionTime :  providedTime;
                        if(this.status === "Dispatched"){
                            this.reliesOnCurrentTimeLine = !upcomingLoad ? true : false;
                            if(currentTimeInMills && providedTime <= currentTimeInMills){                                
                                if(!endOfThePickupWindow || endOfThePickupWindow <= currentTimeInMills){
                                    this.status = "Late"
                                    this.reliesOnCurrentTimeLine = false;
                                }else if(endOfThePickupWindow){
                                    this.hasToCheckInBefore = endOfThePickupWindow;
                                }
                            }else{
                                this.hasToCheckInBefore = providedTime;
                            }
                        }
                        if(this.status === "Dispatched" && endOfThePickupWindow){
                            this.pickupWindowWidth = calculateOffset(endOfThePickupWindow, firstPuCheckInTimeInMilliseconds);
                        }
                        if((this.status === "NotDispatched" || this.status === "Dispatched")&& ((!endOfThePickupWindow && providedTime < lastSpecifiedActionTime) || (endOfThePickupWindow && endOfThePickupWindow < lastSpecifiedActionTime))){
                            this.warnings["0"] = true;
                        }
                    }else{
                        if(lastSpecifiedActionTime && lastSpecifiedActionTime >  providedTime && lastSpecifiedActionTime < plus24H(providedTime) && lastSpecifiedActionTime > currentTimeInMills){
                            firstPuCheckInTimeInMilliseconds = lastSpecifiedActionTime;
                        }else{
                            if(currentTimeInMills > providedTime){
                                if(currentTimeInMills >= plus24H(providedTime)){
                                    firstPuCheckInTimeInMilliseconds = plus24H(providedTime);
                                    if(this.status === "Dispatched")this.status = "Late";
                                }else{
                                    firstPuCheckInTimeInMilliseconds = currentTimeInMills;
                                    this.reliesOnCurrentTimeLine = true;
                                }
                            }else{
                                firstPuCheckInTimeInMilliseconds = providedTime;
                            }
                        }
                    }
                }else{
                    firstPuCheckInTimeInMilliseconds = lastSpecifiedActionTime && lastSpecifiedActionTime > providedTime ? (lastSpecifiedActionTime + (2 * 60 * 60 * 1000)) : providedTime;
                }
                this.providedStartTime = providedTime;
                this.startOffset = calculateOffset(firstPuCheckInTimeInMilliseconds, timelineStartInMilleseconds);
            }
            
            
            this.loadEndDateTime = lastStopObj.lbl;
            this.destCity = lastStopObj.stopCity;
            this.destState = lastStopObj.stopState;
            this.destLatLng = lastStopObj.latLng || null;
            
            
            this.loadsLastActionSpecified = new Date(lastStopObj.appt).getTime();
            if(this.endPercentage){
                // const endTime = new Date(lastStopObj.appt).getTime();
                const diff = this.loadsLastActionSpecified - providedTime;
                this.loadsLastActionSpecified=providedTime + (diff * this.endPercentage);
                this.status = "ReadyForInvoice"
                // this.startOffset =  calculateOffset(firstPuCheckInTimeInMilliseconds, timelineStartInMilleseconds);
            }else{
                if(!this.currentLoad){
                    if(currentTimeInMills && currentTimeInMills < this.loadsLastActionSpecified){
                        this.loadsLastActionSpecified = currentTimeInMills;
                    }
                }else if(lastStopObj.apptTimeProvided ){
                    let endOfTheDelWindow = !lastStopObj.windowDuration ? null : this.loadsLastActionSpecified + (lastStopObj.windowDuration * 60 * 60 * 1000);
                    // if(endOfTheDelWindow && endOfTheDelWindow > currentTimeInMills){
                    //     this.loadsLastActionSpecified = currentTimeInMills
                    // }
                    if(!lastDelCheckOutTimeInMilliseconds && currentTimeInMills > this.loadsLastActionSpecified){
                        if(!endOfTheDelWindow || currentTimeInMills > endOfTheDelWindow){
                            this.loadsLastActionSpecified = currentTimeInMills;
                            if(lastStopObj.stopStatus !== 'inProgress'){
                                this.status = "LateForDelivery";
                            }
                        }
                        
                        // else if(endOfTheDelWindow){
                        //     if(this.etaData){
                        //         try {
                        //             const etaMs = parseTimeStringToMs(this.etaData.eta, this.loadsLastActionSpecified);
                        //             if(etaMs){
                        //                 this.loadsLastActionSpecified = Math.min(etaMs, endOfTheDelWindow);
                        //             }
                        //         } catch (error) {
                                    
                        //         }
                                
                        //     }
                        // }
                    }
                    if(this.etaData && (this.etaData.late || endOfTheDelWindow) && !this.etaData.eta.includes("iles away")  && this.etaData.etaToLastStop){
                        const etaMs = parseTimeStringToMs(this.etaData.eta, currentTimeInMills);
                        if(etaMs && (!endOfTheDelWindow || (etaMs > this.loadsLastActionSpecified))){
                            this.loadsLastActionSpecified = etaMs;
                        }
                    }
                }else if(!lastDelCheckOutTimeInMilliseconds && !upcomingLoad){
                    if(this.loadsLastActionSpecified < currentTimeInMills && plus24H(this.loadsLastActionSpecified) > currentTimeInMills){
                        this.loadsLastActionSpecified = currentTimeInMills;
                    }else{
                        this.loadsLastActionSpecified = this.loadsLastActionSpecified > currentTimeInMills ? this.loadsLastActionSpecified : plus24H(this.loadsLastActionSpecified);
                    }
                }
            }
            this.loadsFirstActionSpecified = firstPuCheckInTimeInMilliseconds;
            this.width = calculateOffset(this.loadsLastActionSpecified, firstPuCheckInTimeInMilliseconds);
            if(this.upcomingLoad){
                this.reliesOnCurrentTimeLine = false;
                this.hasToCheckInBefore = null;
            }
            
        }
        
    }
    adjustBlockWidth(loadData, currentTimeInMills, timelineStartInMilleseconds){ 
        
        const objectClone = cloneDeep(loadData);
        if(objectClone.status === "NotDispatched" || objectClone.status === "Dispatched"){
            objectClone.startOffset = calculateOffset(currentTimeInMills, timelineStartInMilleseconds);
        }else{
            objectClone.reliesOnCurrentTimeLine = false;
        }
        return objectClone;
    }
    adjustStartOffsett(loadData, updatedPrevLoadEndTime, timelineStartInMilleseconds){
        const objectClone = cloneDeep(loadData);
        if(this.providedStartTime >= updatedPrevLoadEndTime){
            delete objectClone.warnings["0"];
        }else{
            objectClone.warnings["0"] = true;
        }
        const newOffset = calculateOffset(updatedPrevLoadEndTime > this.providedStartTime?updatedPrevLoadEndTime:this.providedStartTime, timelineStartInMilleseconds);
        
        objectClone.width = objectClone.width + (objectClone.startOffset - newOffset);
        objectClone.startOffset = newOffset;
        return objectClone;
    }
}


function applyStartEndPercentages(load, currentTruckId){
    if(load.distributionByTrucksPresent && load.loadExecutors && Array.isArray(load.loadExecutors)){
        const executorsArray = load.loadExecutors;
        let lastPercentage = null;
        
        for(let i = 0; i < executorsArray.length; i++){
            try {
                
                const executor = executorsArray[i];
                
                if(executor && executor.id === currentTruckId){
                    
                    if(i === 0){
                        return{
                            startPercentage: null,
                            endPercentage: executor.percentage
                        }
                    }else if(i === executorsArray.length-1){
                        return {
                            startPercentage: Number((1 - executor.percentage).toFixed(2)),
                            endPercentage: null
                        }
                    }else{
                        // Calculate cumulative percentage
                        return {
                            startPercentage: lastPercentage,
                            endPercentage: Number((executor.percentage + lastPercentage).toFixed(2))
                        }
                    }
                }
                lastPercentage = executor.percentage;
            } catch (error) {
                console.error('Error parsing executor:', error);
                continue; // Skip invalid executor entries
            }
        }
    }
    return {};
}